module.exports = __webpack_public_path__ + "media/images/team/Morfu-0b5d7be4340204465063377c5bd67f3d.png";